import { useMemo } from "react"
import { Delivery } from "../../../state/types"
import { Column, FieldType, Section, Table } from "../../../../../features/ui"
import { Data, DataValue2 } from "../../../../../features/data-types"
import { DeliveryLink } from "../delivery-link/deliveryLink"

type Props = {
    shipments: Delivery[]
}

export const ShipmentLinksTable = (props: Props) => {
    const { shipments } = props

    const rows = useMemo(() => shipments.map(shipment => ({
        id: shipment.id,
        link: shipment.id
    })), [shipments])
    
    const detailColumns: Column[] = [
        {
            name: 'link',
            type: FieldType.TEXT,
            label: 'Envíos',
            render: (value?: DataValue2) => {
                const delivery = shipments.find(shipment => shipment.id === value)!
                return <DeliveryLink delivery={delivery} />
            }
        }
    ]
    
    return (
        <Section
            id="shipment-links"
            space={12}
            smallFont
        >
            <Table
                columns={detailColumns}
                rows={rows as Data[]}
                rowId="id"
                readOnly
                alignRight={false}
            />
        </Section>
    )
}
